import $ from 'jquery';

import {util} from './util';

export const discounts = {
  $banner: $('#top-banner-container'),
  rechargeCookieName: 'recharge_discount_code',
  shopifyCookeName: 'discount_code',
  init() {
    const self = this;
    $(() => {
      const onetime = util.detectOnetimeOrder();
      self.$banner = $('#top-banner-container');

      // Initialize discountCode variable as false
      let discountCode = false;
      const defaultDiscountCode = $('#default-discount-code').val();

      if (defaultDiscountCode) {
        var overwriteCode = true;
      } else {
        var overwriteCode = false;
      }

      // Process any discount codes present in the URL parameters. Afterwards, execute this callback function...
      self.processDiscountCode(() => {

        // Fetch the discount code cookie
        discountCode = self.getDiscountCode();

        if (discountCode) {
          // Print the discount code on the page
          $('.discount-code-name').html(discountCode.code.toUpperCase());
        }

        // If the cookie exists and we are not in the customer meal editor panel...
        if (discountCode && !$('#customer-meal-editor').length) {

          // TOP BANNER MODIFICATIONS
          // Add discount information to top banner
          self.$banner.html(`<div id="top-banner">${self.topBannerDiscount(discountCode, onetime)}</div>`);

          // HIDE VISION BANNER
          $('#vision-banner').hide();

          // handle banner visibility
          if (onetime === null) {
            self.$banner.show();
          } else if (
            (discountCode.applies_to_product_type === 'SUBSCRIPTION' && onetime) ||
            (discountCode.applies_to_product_type === 'ONETIME' && !onetime)
          ) {
            self.$banner.hide();
          } else {
            self.$banner.show();
          }

          const event = new Event('banner:updated');
          window.dispatchEvent(event);

          // PLAN FREQUENCY MODIFICATIONS
          if ($('#frequency-discount-details').length) {
            $('#frequency-discount-details').html(self.discountHeadline(discountCode, onetime));
          }


          // LANDING PAGE MODIFICATIONS

          // If a Hero panel exists on this page...
          if ($('#panel-hero').length || $('#panel-hero-split').length) {
            $('#panel-hero-headline-discount').html(self.discountForAmountOff(discountCode));
            $('#panel-hero-headline-discount-get').html(self.discountGetAmountOff(discountCode));
            $('#panel-hero-discount').html(self.discountShowPriceList(discountCode));
            $('#panel-hero .ca-form-submit-updatecta, #panel-hero-split .ca-form-submit-updatecta').html(self.discountGetAmountOff(discountCode));
          }

          // If a Get Started panel exists on this page...
          if ($('#panel-get-started').length) {
            $('#panel-get-started-content-headline-discount').html(` ${self.discountForAmountOff(discountCode)}`);
            $('#panel-get-started-content-discount').html(self.discountShowPriceList(discountCode));
            $('#panel-get-started .ca-form-submit-updatecta').html(self.discountGetAmountOff(discountCode));
          }


          // PRODUCT PAGE MODIFICATIONS
          // If the discount is product-specific, scan the page for prices of the matching product, and update if found.
          // This occurs on product bundle PDPs.

          if (discountCode.applies_to === 'shopify_product') {
            const productPrices = document.querySelectorAll(
              `.product-bundle-price[data-product-id="${discountCode.applies_to_id}"]`,
            );
            productPrices.forEach((productPrice) => {
              productPrice.classList.add('has-discount');
              productPrice.parentElement.classList.add('has-discount');
              const originalPrice = Number(productPrice.dataset.productPrice)/100;
              const discountedPrice = this.calculateDiscountedBoxPrice(discountCode, originalPrice, onetime, 0);
              if (discountedPrice) {
                productPrice.querySelector('.price-discounted').innerHTML = `$${discountedPrice}`;
              }
            });
          }

        }

      }, defaultDiscountCode, overwriteCode);

    });
  },

  discountHeadline(d, onetime) {
    if (d.discount_type == 'fixed_amount') {
      if (d.duration == 'single_use' && !onetime && d.applies_to_product_type === 'SUBSCRIPTION') {
        return `$${d.value} off first box`;
      } else {
        return `$${d.value * (d.duration_usage_limit || 1)} off`;
      }
    } else if (d.discount_type == 'shipping') {
      return 'Free shipping';
    } else if (d.applies_to_product_type === 'ONETIME') {
      return `${d.value}% off`;
    } else if (d.duration == 'single_use' && !onetime && d.applies_to_product_type === 'SUBSCRIPTION') {
      return `${d.value}% off first box`;
    } else if (d.duration == 'single_use' && !onetime && d.applies_to_product_type === 'ONETIME') {
      return `${d.value}% off`;
    } else if (d.duration_usage_limit === 1) {
      return `${d.value}% off`;
    } else {
      return `${d.value}% off first ${d.duration_usage_limit} boxes`;
    }
  },

  discountText(d) {
    if (d.discount_type == 'fixed_amount') {
      if (d.duration == 'single_use') {
        return `Code ${d.code.toUpperCase()} automatically applied at checkout`;
      } else {
        return `$${d.value} off first ${d.duration_usage_limit} boxes with code ${d.code.toUpperCase()}`;
      }
    } else if (d.discount_type == 'shipping') {
      if (d.duration == 'single_use') {
        return `Code ${d.code.toUpperCase()} automatically applied at checkout`;
      } else {
        return `Free shipping on first ${d.duration_usage_limit} boxes with code ${d.code.toUpperCase()}`;
      }
    } else if (d.duration == 'single_use') {
      return `Code ${d.code.toUpperCase()} automatically applied at checkout`;
    } else {
      return `${d.value}% off first ${d.duration_usage_limit} boxes with code ${d.code.toUpperCase()}`;
    }
  },

  discountAmountOff(d) {
    if (d.discount_type == 'fixed_amount') {
      if (d.duration == 'single_use') {
        return `$${d.value} off`;
      } else {
        return `$${d.value * d.duration_usage_limit} off`;
      }
    } else if (d.discount_type == 'shipping') {
      return 'free shipping';
    } else if (d.duration == 'single_use') {
      return `${d.value}% off`;
    } else {
      return `${d.value}% off ${d.duration_usage_limit} boxes`;
    }
  },

  discountForAmountOff(d) {
    if (d.discount_type == 'shipping') {
      return 'with free shipping';
    } else {
      return `for ${this.discountAmountOff(d)}`;
    }
  },

  discountGetAmountOff(d) {
    if (d.discount_type == 'shipping') {
      return 'Get free shipping';
    } else {
      return `Get ${this.discountAmountOff(d)}`;
    }
  },

  discountShowProductDiscount(productPrice, d) {

    let newPrice;
    if (d.discount_type == 'fixed_amount') {
      newPrice = (productPrice - d.value).toFixed(2);
    } else if (d.discount_type == 'shipping') {
      newPrice = productPrice.toFixed(2);
    } else {
      newPrice = (productPrice * (1 - d.value)).toFixed(2);
    }

    let discountReadout;
    if (d.discount_type == 'fixed_amount') {
      if (d.duration == 'single_use') {
        discountReadout = `$${d.value} discount applied`;
      } else {
        discountReadout = `$${d.value} discount applies to first ${d.duration_usage_limit} orders ($${d.value * d.duration_usage_limit} total)`;
      }
    } else if (d.discount_type == 'shipping') {
      if (d.duration == 'single_use') {
        discountReadout = 'Free shipping applied';
      } else {
        discountReadout = `Free shipping applies to first ${d.duration_usage_limit} orders`;
      }
    } else if (d.duration == 'single_use') {
      discountReadout = `${d.value}% off discount applied`;
    } else {
      discountReadout = `${d.value}% off discount applies to first ${d.duration_usage_limit} orders`;
    }

    return `<div class="old-price">$${productPrice}</div><div class="new-price">$${newPrice}</div><div class="discount-readout"><i class="fas fa-check-circle"></i> ${discountReadout}</div>`;
  },

  discountShowPriceList(d) {
    if (d.discount_type == 'fixed_amount') {
      if (d.duration == 'single_use') {
        return '';
      } else {
        let priceList = '<p class="panel-price-list">';
        if (d.duration_usage_limit == 1) {
          return '';
        } else if (d.duration_usage_limit == 2) {
          priceList += `1st order: <span class="panel-price-list-price">$${d.value} off</span></p><p class="panel-price-list">2nd order: <span class="panel-price-list-price">$${d.value} off</span>`;
        } else {
          priceList += `$${d.value} off each of your first ${d.duration_usage_limit} orders`;
        }
        priceList += '</p>';
        return priceList;
      }
    } else {
      return '';
    }
  },

  topBannerDiscount(d, onetime) {
    return `<i class="fas fa-check-circle"></i> <strong>${this.discountHeadline(d, onetime)}</strong>: ${this.discountText(d)}`;
  },

  hideBanner(shouldDisableDiscount) {
    // Handle Banner Visibility
    shouldDisableDiscount ? this.$banner.hide() : this.$banner.show();
  },

  getDiscountCode() {
    // When shopify checkout is enabled, the customer will only have a discount
    // auto-applied at checkout of a specific shopify cookie is set. So we need to
    // remove the stored recharge coupon state if its missing, since the user will
    // not receive the discount code in that case.
    if (!Cookies.get('discount_code')) {
      Cookies.remove('recharge_discount_code');
    }

    const d = Cookies.getJSON('recharge_discount_code');
    if (d) {
      if ('code' in d || 'price rule' in d) {
        return d;
      } else {
        Cookies.remove('recharge_discount_code');
        return null;
      }
    } else {
      Cookies.remove('recharge_discount_code');
      return null;
    }
  },

  processDiscountCode(callback, defaultDiscountCode, overwrite = false) {
    const toRemove = util.getUrlParam('remove_discount', null) || util.getUrlParam('remove_discounts', null);
    if (toRemove === 'true') {
      Cookies.remove('recharge_discount_code');
      const discountProcessed = new CustomEvent('discount:processed', {
        detail: {
          response: 'removed',
        },
      });
      document.dispatchEvent(discountProcessed);
      return null;
    }

    const defaultCode = JSON.parse($('#mosaicSettings').html());
    defaultDiscountCode = defaultDiscountCode || defaultCode;

    // Get discount code from the URL arguments; on shopify, it is stored in a cookie
    let discountParam = util.getUrlParam('discount_code', null) || Cookies.get('discount_code');
    const aicParam = util.getUrlParam('aic', null);

    if (!discountParam && defaultDiscountCode) {
      if (overwrite) {
        discountParam = defaultDiscountCode;
      } else if (!this.getDiscountCode()) {
        discountParam = defaultDiscountCode;
      }
    }

    // If an aicParam URL argument is provided, update the cookie and set discountCode
    if (aicParam) {
      const aicCode = `FRIEND-${aicParam}`;

      $.ajax({
        type: 'POST',
        url: `${window.location.origin}/apps/mosaic-api/get-discount/`,
        dataType: 'json',
        async: false,
        data: {discount_code: aicCode},
        success(response) {
          if (response.code) {
            Cookies.remove('recharge_discount_code');
            Cookies.set('recharge_discount_code', response, {expires: 7});

            const discountProcessed = new CustomEvent('discount:processed', {
              detail: {
                response,
              },
            });
            document.dispatchEvent(discountProcessed);
          }
        },
        error(err) {
        },
        complete(data) {
          callback();
        },
      });
    } else {
      // If a discountParam URL argument is provided, update the cookie and set discountCode
      if (discountParam) {
        $.ajax({
          type: 'POST',
          url: `${window.location.origin}/apps/mosaic-api/get-discount/`,
          dataType: 'json',
          async: false,
          data: {discount_code: discountParam},
          success(response) {
            if (response.code) {
              Cookies.remove('recharge_discount_code');
              Cookies.set('recharge_discount_code', response, {expires: 7});


              const discountProcessed = new CustomEvent('discount:processed', {
                detail: {
                  response,
                },
              });
              document.dispatchEvent(discountProcessed);
            }
          },
          error(err) {
          },
          complete(data) {
            callback();
          },
        });
      } else {
        callback();
      }
    }
  },

  calculateDiscountedBoxPrice(d, boxPrice, onetime, precision = 2) {
    if (d && 'price rule' in d) {
      d = d['price rule'];
      if (d.value_type == 'fixed_amount') {
        return Math.max(boxPrice - Math.abs(d.value), 0).toFixed(precision);
      } else if (d.value_type == 'percentage') {
        return Math.max(boxPrice * (1 - (Math.abs(d.value) / 100)), 0).toFixed(precision);
      } else {
        // shipping
        return false;
      }
    } else if (d && 'code' in d) {
      if (onetime && d.applies_to_product_type === 'SUBSCRIPTION' || !onetime && d.applies_to_product_type === 'ONETIME') {
        return false;
      }
      if (d.discount_type == 'fixed_amount') {
        return Math.max(boxPrice - d.value, 0).toFixed(precision);
      } else if (d.discount_type == 'percentage') {
        return Math.max(boxPrice * (1 - (d.value / 100)), 0).toFixed(precision);
      } else {
        // shipping
        return false;
      }
    } else {
      return false;
    }
  },

  calculateDiscountCents(d, items, onetime, otherDiscountableCharges = 0) {
    const boxPrice = items.reduce(
      (sum, item) => sum + (item.planDiscountPrice * item.item.quantity),
      0,
    ) + otherDiscountableCharges;
    if (d && 'price rule' in d) {
      d = d['price rule'];
      if (d.value_type == 'fixed_amount') {
        return Math.min(boxPrice, (Math.abs(d.value) * 100));
      } else if (d.value_type == 'percentage') {
        const percentage = (Math.abs(d.value) / 100);
        return items.reduce((sum, item) => {
          return sum + (Math.round(item.planDiscountPrice * percentage) * item.item.quantity);
        }, 0);
      } else {
        return 0;
      }
    } else if (d && 'code' in d) {
      if (onetime && d.applies_to_product_type === 'SUBSCRIPTION' || !onetime && d.applies_to_product_type === 'ONETIME') {
        return 0;
      }
      if (d.discount_type == 'fixed_amount') {
        return Math.min(boxPrice, d.value) * 100;
      } else if (d.discount_type == 'percentage') {
        const percentage = d.value / 100;
        return items.reduce((sum, item) => {
          return sum + (Math.round(item.planDiscountPrice * percentage) * item.item.quantity);
        }, 0);
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  },

  refreshPrice(selectors, price, discountedPrice, discountCode, shouldDisableDiscount, onetime) {
    const {
      $price,
      $priceShipping,
      $discountedPrice,
      $discountDetail,
    } = selectors;
    $price.html(`$${(price / 100).toFixed(2)}${shouldDisableDiscount ? '' : '<span class="hide-on-strikethrough"></span>'}`);

    if (discountedPrice) {
      if (shouldDisableDiscount) {
        $priceShipping.addClass('price-shipping-discount');
      } else {
        $priceShipping.removeClass('price-shipping-discount');
      }

      $price.addClass('discount-color');
      $price.addClass('price-confirmation-strikethrough');
      $discountedPrice.html(`$${discountedPrice} `);
      $discountedPrice.show();
      $priceShipping.addClass('discount-color');
      if (discountCode && !shouldDisableDiscount) {
        if (discountCode.duration === 'usage_limit' && !onetime) {
          if (discountCode.duration_usage_limit > 1) {
            $discountDetail.html(`<i class="fas fa-check-circle"></i> Discount on first ${discountCode.duration_usage_limit} deliveries`);
          }
        } else {
          const discountWithType = discountCode.discount_type === 'percentage' ? `${discountCode.value}%` : `$${discountCode.value}`;
          const text = `${discountWithType} off ${discountCode.duration === 'single_use' && !onetime && discountCode.applies_to_product_type === 'SUBSCRIPTION' ? 'first box' : ''}`;
          $discountDetail.html(`<i class="fas fa-check-circle"></i> ${text}`);
        }
      }
    } else if (discountCode && discountCode.discount_type === 'shipping') {
      if (shouldDisableDiscount) {
        $priceShipping.addClass('price-shipping-discount');
      } else {
        $priceShipping.removeClass('price-shipping-discount');
      }
      $discountedPrice.html('');
      $discountedPrice.hide();
      $discountDetail.html('<i class="fas fa-check-circle"></i> Free shipping discount');
    } else {
      $price.removeClass('discount-color');
      $price.removeClass('price-confirmation-strikethrough');
      $discountedPrice.html('');
      $discountedPrice.hide();
      $priceShipping.removeClass('discount-color');
      $discountDetail.html('');
    }
  },

  refreshShipping($priceShipping, price, discountCode, customShippingRate, priceShippingThreshold) {
    if (price >= priceShippingThreshold || (discountCode && discountCode.discount_type === 'shipping')) {
      $priceShipping.text('+ Free Shipping');
    } else {
      $priceShipping.text(`+ ${customShippingRate} shipping`);
    }
  },
};
